import React from "react";
import Carousel from "react-multi-carousel";
import { useTranslation } from "../../i18n";

export default function ServiceTeamsComponents() {
  const { t } = useTranslation();
  const responsiveTeams = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 5,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };
  return (
    <div className="services_content_teams mt-3">
      <div className="header">
        <h2 className="font-vietnam-600">{t.services.skillsTitle}</h2>
        <label htmlFor="" className="font-vietnam-200-italic">
          {t.services.skillsBody[0]} <br /> {t.services.skillsBody[1]} <br />{" "}
          {t.services.skillsBody[2]}
        </label>
      </div>
      <div className="content">
        <Carousel
          responsive={responsiveTeams}
          autoPlaySpeed={4000}
          autoPlay={true}
          infinite={true}
          ssr={true}
          arrows={false}
        >
          <div
            style={{
              backgroundImage: `url(${require("../../assets/images/services/teams_marketing.jpg")})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              width: "100%",
            }}
            className="teams"
          >
            <div className="teams_description">
              <h3 className="font-vietnam-600-italic">{t.services.teams[0]}</h3>
            </div>
          </div>
          <div
            style={{
              backgroundImage: `url(${require("../../assets/images/services/teams_server.jpg")})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              width: "100%",
            }}
            className="teams"
          >
            <div className="teams_description">
              <h3 className="font-vietnam-600-italic">{t.services.teams[1]}</h3>
            </div>
          </div>
          <div
            style={{
              backgroundImage: `url(${require("../../assets/images/services/teams_design.jpg")})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              width: "100%",
            }}
            className="teams"
          >
            <div className="teams_description">
              <h3 className="font-vietnam-600-italic">{t.services.teams[2]}</h3>
            </div>
          </div>
          <div
            style={{
              backgroundImage: `url(${require("../../assets/images/services/teams_seo.jpg")})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              width: "100%",
            }}
            className="teams"
          >
            <div className="teams_description">
              <h3 className="font-vietnam-600-italic">{t.services.teams[3]}</h3>
            </div>
          </div>
          <div
            style={{
              backgroundImage: `url(${require("../../assets/images/services/teams_programing.jpg")})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              width: "100%",
            }}
            className="teams"
          >
            <div className="teams_description">
              <h3 className="font-vietnam-600-italic">{t.services.teams[4]}</h3>
            </div>
          </div>
        </Carousel>
      </div>
    </div>
  );
}
